import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignCenterSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 3h8v1H2V3ZM1 6h10v1H1V6ZM2 9h8v1H2V9Z" />
  </svg>
);
export default IconAlignCenterSizeXs;
